import React, { useContext, useEffect, useState } from "react";
import { JSDCContext, JSDCProvider } from "jsdc-dui/dist/JSDC/Context";
import JSDC from "jsdc-dui/dist/JSDC";
import { latLng, latLngBounds } from "leaflet";
import {
  IDuiContextProviderProps,
  DuiContextProvider,
} from "jsdc-dui/dist/components/Context";
import DguideWalksApp from "jsdc-dui/dist/components/DguideWalksApp";
import { DguidewalksProvider } from "jsdc-dui/dist/JSDC/Dguidewalks/Context";
import "jsdc-dui/dist/style/index.css";
import "./index.scss";
import ConfigProvider from "jsdc-dui/dist/JSDC/Dguidewalks/ConfigProvider";
import headerImg from "./assets/key-art_Desktop.png";
import headerImgMb from "./assets/key-art_mobile.jpg";
import aboutImg from "./assets/about.png";


//TODO: EVENT_ID
const EVENT_ID = "n0022";

//TODO: aboutWalkContent
const aboutWalkContent = `說起台灣北部地區的茶葉種植、生產及出口大概始於清道光中葉（1830~1840年代），而早期來到三峽拓墾的福建安溪人民，也因原籍地種植茶樹、製茶，將這一產業、技術經驗帶入三峽地區。
至道光中葉，三峽已有茶葉出口的記錄，在同治4年（1865），台灣開港通商，蘇格蘭商人陶德來台採購樟腦的同時，也發現北台灣近山地區的氣候及土質非常適合種植茶葉，便從福建安溪運來茶苗，並以貸款方式鼓勵農民種茶，故在同年艋舺德春行黃龍安兄弟三人，帶領族親到三峽山區開墾植茶。
同治7年（1868），陶德在文山堡（包括今日的文山、新店、深坑、石碇、坪林、雙溪等區）、海山堡（包含今日的樹林、三峽、鶯歌、部分新莊、大溪等區）推廣茶樹的種植，也拓展到三峽地區的十三添庄（今日的三峽區嘉添里西北部、添福里北半部）。
同治8年（1869），三峽種茶區域也擴大到橫溪、成福、鳶山、福德康等地，此時三峽地區的菁靛（藍染的染料）、採樟及種茶成為三峽的重要產業與物產集散地。
本次走讀路線設計與三峽茗茶的興起與變遷有關，有李梅樹紀念館、三峽區農會、林信記古厝、天芳茶行、九鬮老街、大寮茶文館、大豹製茶廠等，供大家來到三峽走讀散步時的人文路線。
`;

//TODO: credit
const credit = `
<div>
    團隊介紹：新北市政府教育局教資科，聯絡電話(02)80723456#636
    <br>
    <br>
    本圖臺是由新北市政府教育局及智紳數位文化有限公司共同協力建置：
    <br>1. 圖臺內容：新北市政府教育局
    <br>2. 圖臺系統開發：智紳數位文化事業有限公司
    <br>
    <br>除另有聲明外，本網站內容採用創用 CC 姓名標示-非商業性-相同方式分享4.0授權條款授權公眾使用，您可以依授權條款複製、引用、轉載，唯請於合理位置標示本站網址：新北市政府教育局 <a href="https://www.ntpc.edu.tw/">https://www.ntpc.edu.tw/</a>
</div>
`;

const duiConfigProps: IDuiContextProviderProps = {
  sidebarTitle: "",
  sidebarSubtitle: "",
  aboutWalkImgSrc: aboutImg,
  aboutWalkContent,
  credit,
  creditHref: "https://www.facebook.com/JRSHENDigitalCulture/",
  headerMBImgSrc: headerImgMb,
  headerDImgSrc: headerImg,
  weatherConfig: {
    token: "CWB-232A270E-12F1-4381-B9F2-DF2D2670A077",
    locations: [{ county: "新北市", town: "三峽區" }], //TODO: weather 氣象預測地點
  },
  themeConfig: {
    "--dui-primary": "#459AF8", //TODO: theme
    "--dui-accent": "#8F4A91", //TODO: 數位集章按鈕顏色, more按鈕
    "--dui-secondary": "#459AF8", //TODO: theme
    "--dui-bg-secondary": "#ffc361", // Dialog background
    "--dui-bg-accent": "#004097", //TODO: background
  },
  settingConfig: {
    disabled: true, // 左側選單不出現「工具設定」
    // languageSwitcherDisabled: true, // 或：保留「工具設定」，只藏語言切換器
  },
};
// #e4e7cb
// 景點的 icon、點擊開集章卡片、cluster、集章 key、`?id=` 深連結、
// 列表的定位與導航、底圖、線、路線顏色選單都由 jsdc-dui 依 Strapi 的資料建立，這裡不需要再處理圖層。
function App() {
  const { Jsdc } = useContext(JSDCContext);

  useEffect(() => {
    (window as any).JSDC = Jsdc;
  }, [Jsdc]);

  return (
    <div className="root">
      <DguideWalksApp language="zh-TW" />
    </div>
  );
}

const config = new ConfigProvider({ eventId: EVENT_ID });

const AppWrapper: React.FC = () => {
  const [Jsdc] = useState(
    new JSDC(EVENT_ID, {
      bound: latLngBounds(
        //TODO: map view bound
        latLng(24.941155469991525, 121.39945320644479),
        latLng(24.861181210742416, 121.41192793615514),
      ),
      maxZoom: 20,
    }),
  );

  return (
    <JSDCProvider Jsdc={Jsdc}>
      <DguidewalksProvider
        Jsdc={Jsdc}
        config={config}
      >
        <DuiContextProvider
          {...duiConfigProps}
          pathColorConfig={{ enabled: true }}
        >
          <App />
        </DuiContextProvider>
      </DguidewalksProvider>
    </JSDCProvider>
  );
};

export default AppWrapper;
